<script setup lang="ts">
import { useVersionCheck } from '@/composables/useVersionCheck';

useVersionCheck();
</script>

<template>
    <slot />
</template>
